import React from 'react';
import { Box, Typography } from '@mui/material';

// Wraps each page section with an anchor id (for the nav bar) and a heading.
const Section = ({ id, title, children }) => {
  return (
    <Box
      component="section"
      id={id}
      sx={{ scrollMarginTop: 80, py: { xs: 4, md: 5 }, borderTop: 1, borderColor: 'divider' }}
    >
      <Typography component="h2" variant="h4" sx={{ mb: 3 }}>
        {title}
      </Typography>
      {children}
    </Box>
  );
};

export default Section;
